module.exports = __webpack_public_path__ + "img/St Barts.1ecc77cb.svg";